import EnvironmentConfig from '../interfaces/EnvironmentConfig';

const e2eQaConfigs: EnvironmentConfig = {
  surveyJsKey: 'empty',
  dashboardClassic: 'https://dashboard.qa.casaretail.ai',
  ingressUrl:"https://ingress.casaqa.ajira.tech",
  ruleServerUrl: 'https://kapi.qa.casaretail.ai',
  apiServerUrl: 'https://kapi.qa.casaretail.ai', // TODO: Need to change
  casaWebAppUrl: 'https://web.qa.casaretail.ai',
  commerceConnect: 'http://commerce-connect.qa.casaretail.ai',
  ruleUIUrl: 'https://rules.qa.casaretail.ai',
  systemPage: true,
  allJourneyFeatures: true,
  pwaUrl: 'qa.casarewards.com',
  dashboard: 'https://dashboard.casaqa.ajira.tech',
  ticketDeskUrl: '',
  keycloakConfig: {
    url: `https://qa.auth.ginesys.one/auth`,
    realm: `GinesysOne`,
    clientId: `GinesysOne`,
  },
  socialMedia: {
    facebook: {
      appId: '787341686188506',
    },
    googleAds: {
      clientId:
        '273230167843-mdnnlq3creq5jouop3kfbvsjg2mqmpl6.apps.googleusercontent.com',
      redirectURI:
        'https://dashboard.casaqa.ajira.tech/settings/integrations/social-media',
    },
  },
};

export default e2eQaConfigs;
